export const urls = require("./urls")
export const variables = require("./variables")
